import { render, staticRenderFns } from "./unsettingPoints.vue?vue&type=template&id=0eaaafa5&scoped=true&"
import script from "./unsettingPoints.vue?vue&type=script&lang=js&"
export * from "./unsettingPoints.vue?vue&type=script&lang=js&"
import style0 from "./unsettingPoints.vue?vue&type=style&index=0&id=0eaaafa5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaaafa5",
  null
  
)

export default component.exports